import moment from 'moment';

// 获取当前日期以及当前日期前一个月的日期
const startDate = () => {
  const end = moment().format('YYYY-MM-DD');
  const start = moment().subtract(30, 'days').format('YYYY-MM-DD'); // 当前日期前一个月
  return [`${start} 00:00:00`, `${end} 23:59:59`];
};

// 获取当前日期以及当前日期前365天的日期
const startDateYear = () => {
  const end = moment().format('YYYY-MM-DD');
  const start = moment().subtract(365, 'days').format('YYYY-MM-DD'); // 当前日期前一年
  return [`${start} 00:00:00`, `${end} 23:59:59`];
};

// 获取当前日期
const setToday = () => {
  const end = moment().format('YYYY-MM-DD');
  const start = moment().format('YYYY-MM-DD'); // 当前日期
  return [start, end];
};

const endDate = datetime => moment(datetime, 'YYYYMMDD').format('YYYY-MM-DD');

// 获取当前日期
const currentDate = moment().format('YYYY-MM-DD');
const currentTime = moment().format('YYYY-MM-DD HH:mm:ss');

const setReasonType = (type) => {
  let reasonType = '';
  switch (type) {
    case '1': reasonType = '自定义';
      break;
    case '2': reasonType = '采购入库';
      break;
    case '3': reasonType = '采购退货';
      break;
    case '4': reasonType = '售药';
      break;
    case '5': reasonType = '退药';
      break;
    case '6': reasonType = '盘点入库';
      break;
    case '7': reasonType = '盘点出库';
      break;
    default: reasonType = '';
      break;
  }
  return reasonType;
};

const setDrugType = (type) => {
  let reasonType = '';
  const types = Number(type);
  switch (types) {
    case -1: reasonType = '全部';
      break;
    case 1: reasonType = '西药';
      break;
    case 2: reasonType = '中药饮片';
      break;
    case 3: reasonType = '中成药';
      break;
    case 4: reasonType = '保健品';
      break;
    case 5: reasonType = '医疗器械';
      break;
    case 6: reasonType = '化妆品';
      break;
    case 7: reasonType = '日用百货';
      break;
    case 8: reasonType = '其他';
      break;
    case 9: reasonType = '贴敷中药';
      break;
    case 10: reasonType = '检查治疗项';
      break;
    case 11: reasonType = '附加费用';
      break;
    default: reasonType = '';
      break;
  }
  return reasonType;
};

// 模板类型
const tempType = (type) => {
  let reasonType = '';
  switch (type) {
    case 1: reasonType = '中药处方';
      break;
    case 2: reasonType = '西药处方';
      break;
    case 3: reasonType = '处方';
      break;
    case 4: reasonType = '输液卡';
      break;
    case 5: reasonType = '病历';
      break;
    case 6: reasonType = '医嘱';
      break;
    case 7: reasonType = '贴敷';
      break;
    default: reasonType = '';
      break;
  }
  return reasonType;
};

// 模板类型-诊所管理
const templateType = (type) => {
  let reasonType = '';
  switch (type) {
    case 1: reasonType = '饮片处方';
      break;
    case 2: reasonType = '成药处方';
      break;
    case 3: reasonType = '处方';
      break;
    case 4: reasonType = '输液处方';
      break;
    case 5: reasonType = '病历';
      break;
    case 6: reasonType = '医嘱';
      break;
    case 7: reasonType = '贴敷处方';
      break;
    default: reasonType = '';
      break;
  }
  return reasonType;
};

// 设置性别
const setGender = (type) => {
  let gender = '';
  if (type === '--') return '--';
  switch (type) {
    case -1: gender = '未知';
      break;
    case 0: gender = '女';
      break;
    case 1: gender = '男';
      break;
    default: gender = '';
      break;
  }
  return gender;
};

// 获取从刘伟那边过来的动态年龄的数据
const getAge = (res) => {
  let str = '';
  if (res.year > 0) {
    str = `${res.year}岁`;
  }
  if (res.month > 0 && res.year >= 0 && res.year < 5) {
    str = `${str} ${res.month}月`;
  }
  if (res.year === 0 && res.day > 0) {
    str = `${str} ${res.day}天`;
  }
  return str;
};

export {
  startDate,
  startDateYear,
  setToday,
  endDate,
  setReasonType,
  setDrugType,
  currentDate,
  tempType,
  templateType,
  setGender,
  currentTime,
  getAge,
};
